<form [formGroup]="dealsLookupForm" (ngSubmit)="searchDeals()">
    <mat-form-field class="col mat-elevation-z2" appearance="fill">
        <mat-label>Search for a customer, deal #, vin, or stock number...</mat-label>
        <mat-placeholder>Search for a customer, deal #, vin, or stock number...</mat-placeholder>
        <input class="form-control" type="text" matInput formControlName="query" />
        <button *ngIf="!isFiltered" matSuffix mat-icon-button type="button">
            <mat-icon role="graphics-symbol" title="Search">search</mat-icon>
        </button>
        <button *ngIf="isFiltered" (click)="clear()" matSuffix mat-icon-button type="button">
            <mat-icon role="graphics-symbol" title="Clear">close</mat-icon>
        </button>
    </mat-form-field>
</form>
<div class="actions">
    <mat-button-toggle-group class="mat-elevation-z2">
        <mat-button-toggle [value]="1" [checked]="selectedDealType === 1" [class.selected]="selectedDealType === 1" (change)="selectDealType($event.value)"
            >Open Deals
        </mat-button-toggle>
        <mat-button-toggle [value]="2" [checked]="selectedDealType === 2" [class.selected]="selectedDealType === 2" (change)="selectDealType($event.value)"
            >Closed Deals
        </mat-button-toggle>
        <mat-button-toggle [value]="3" [checked]="selectedDealType === 3" [class.selected]="selectedDealType === 3" (change)="selectDealType($event.value)"
            >Archived Deals
        </mat-button-toggle>
    </mat-button-toggle-group>
</div>
<div id="deals" class="container">
    <div class="deal-card mat-elevation-z2 add-deal-card">
        <a [routerLink]="'/deals/create'"><span>+ Add Deal</span></a>
    </div>

    <app-deal-card *ngFor="let deal of deals" [deal]="deal" [dealUrl]="['/deals', 'deal', '' + deal.dealId]"></app-deal-card>
</div>
